export enum MetricType {
  Accumulator = 1,
  Counter = 2,
  Spring = 3,
}
